module.exports = __webpack_public_path__ + "static/img/pagelogo1.eb23e95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgCata/pagelogo1.png
// module id = 5WGg
// module chunks = 47